import styled from 'styled-components'

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    font-size: 16px;
    font-weight: 500;
    font-family: 'Inter';
    margin-bottom: 36px;
  }
`
